import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconOldJoystick: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconOldJoystick"><Path d="M12 3C13.933 3 15.5 4.567 15.5 6.5C15.5 8.17545 14.3224 9.57452 12.75 9.91797V14H16.5V11.75C16.5 11.3358 16.8358 11 17.25 11C17.6642 11 18 11.3358 18 11.75V14H18.25C19.7688 14 21 15.2312 21 16.75V18.25C21 19.7688 19.7688 21 18.25 21H5.75C4.23122 21 3 19.7688 3 18.25V16.75C3 15.2312 4.23122 14 5.75 14H11.25V9.91797C9.67756 9.57452 8.5 8.17545 8.5 6.5C8.5 4.567 10.067 3 12 3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconOldJoystick;
